import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Observable, debounceTime, distinctUntilChanged, map, filter } from 'rxjs';
import { MsgModel } from '../msg/model/msg.model';

@Component({
    selector: 'input-email-confirm',
    templateUrl: './input-email-confirm.component.html',
    styleUrls: ['./input-email-confirm.component.scss']
})
export class InputEmailConfirmComponent implements OnInit, OnChanges {
    @Input() matLabel: string = 'Confirm Email Address';
    @Input() placeholder: string = 'Confirm Email Address';
    @Input() form!: UntypedFormGroup;
    @Input() controlName!: string;
    @Input() targetControlName!: string;

    @Input() emailToConfirm!: string;

    isLoading: boolean = false;
    msg!: MsgModel;

    emailControl: any;
    emailConfirmControl: any;
    emailConfirmOptions!: Observable<any>;

    minCharacters: number = 3;

    constructor() {}

    ngOnInit(): void {
        this.emailControl = <UntypedFormControl>this.form.get(this.targetControlName);
        this.emailConfirmControl = <UntypedFormControl>this.form.get(this.controlName);

        this.emailConfirmOptions = this.emailConfirmControl.valueChanges.pipe(
            // only search if search string is >= 3 characters
            filter((text: string) => text !== null && text.length >= this.minCharacters && this.validateEmail(text, this.emailConfirmControl)),
            debounceTime(500),
            distinctUntilChanged(),
            map((value) => this.checkEmail())
        );
    }

    checkEmail() {
        this.emailConfirmControl.setErrors(this.emailControl.value === this.emailConfirmControl.value ? null : { confirmEmail: true });

        if (this.emailControl.value === this.emailConfirmControl.value) {
            this.msg = { SUCCESS: true };
        } else {
            this.msg = { MSG: 'Please confirm your email.', SUCCESS: false };
        }
    }

    validateEmail(email: string, form: UntypedFormControl) {
        const regularExpression =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const isEmail = regularExpression.test(String(email).toLowerCase());

        this.emailConfirmControl.setErrors(isEmail ? null : { email: true });

        return isEmail;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.emailControl && this.emailConfirmControl) {
            this.checkEmail();
        }
        // You can also use categoryId.previousValue and
        // categoryId.firstChange for comparing old and new values
    }
}
